import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import buttonWidgetIcon from "../../assets/images/button_widget.svg";

Scrivito.provideEditingConfig("ButtonWidget", {
  title: "Button",
  thumbnail: buttonWidgetIcon,
  attributes: {
    ...localizeAttrList(
      ["alignment", "target", "fallbacktitle"],
      "ButtonWidget"
    ),
    noMargin: {
      title: "No margin",
      description:
        "Remove the bottom margin of the button. Usefull for button at the end of a section or container.",
    },
    style: {
      title: "Style",
      description: "Select the button's style.",
      values: [
        { title: "CTA (Yellow)", value: "yellow" },
        { title: "Info Button 1 (White)", value: "white" },
        { title: "Info Button 2 (Blue)", value: "blue" },
        { title: "Info Button 3 (Light Blue)", value: "light-blue" },
        { title: "Liv Button 1 (Teal)", value: "teal" },
        { title: "Liv Button 2 (Light Teal)", value: "light-teal" },
      ],
    },
  },
  properties: ["target", "alignment", "style", "noMargin", "fallbacktitle"],
  initialContent: {
    alignment: "full-width",
    style: "blue",
    noMargin: false,
    target: new Scrivito.Link({
      title: "Scrivito",
      url: "https://scrivito.com",
      target: "_blank",
    }),
  },
});
